module.exports = __webpack_public_path__ + "5d9fdab49e04e182810b432d27cd654b.png";